import React from 'react';

import { MODULE_NAME } from '../../constants';

import { isSSR } from '../../helpers/ssr';

import { scrollToElement } from '../../utils/domUtils';

import { isHotelUrl } from '../../utils/uriUtils';

import { SEARCH_WIDGET_SETTINGS } from './constants';

import type { ISearchWidgetInitializer } from './types';

export class SearchWidgetInitializer extends React.PureComponent<ISearchWidgetInitializer> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private search_form: any;

  componentDidMount() {
    if (!isSSR) {
      this.renderWidget();
    }
  }

  componentDidUpdate(prevProps) {
    const { searchParams } = this.props;
    if (searchParams) {
      const { start_date: startDate, nights, adults } = searchParams;

      if (startDate !== prevProps.searchParams.start_date) {
        this.search_form.setParams({
          adults,
          nights,
          start_date: startDate,
        });
      }
    }
  }

  searchParamsChanged(response, callback) {
    const { onChangeSearchParams } = this.props;
    const { redirect_url: url } = response;

    if (!isSSR && isHotelUrl(url)) {
      window.location.href = url;
      return;
    }
    onChangeSearchParams(url);
    callback();
    scrollToElement(document.body);
  }

  renderWidget() {
    const { searchParams, appName, isMobile } = this.props;
    const isSearchApp = appName === MODULE_NAME.SEARCH;
    this.search_form =
      window.LTApi &&
      new window.LTApi.Widgets.SearchWidget({
        ...SEARCH_WIDGET_SETTINGS,
        preventMobile: !isMobile,
        onSearchPerform: isSearchApp && this.searchParamsChanged.bind(this),
        search_params: searchParams,
      });

    return this.search_form;
  }

  render() {
    return null;
  }
}
